import React, { FC } from 'react';

interface RoleCardProps {
  icon: string
  teamRole: string
  title: string
  description: string
}

const RoleCard: FC<RoleCardProps> = ({
  icon,
  teamRole,
  title,
  description,
}) => (
  <article
    className={`
      w-full flex items-start gap-3 p-4 border-b border-slate-200
      last:border-b-0 bg-white
      md:flex-1 md:min-w-[180px] md:flex-col md:items-center
      md:p-4 md:border md:border-slate-200 md:rounded-lg-plus
      md:bg-gray-50 md:text-center md:last:border-b
    `}
  >
    <span
      className="flex-shrink-0 w-10 h-10 rounded-lg bg-slate-100 flex items-center justify-center text-xl md:block md:w-auto md:h-auto md:bg-transparent md:text-3xl md:mb-2"
      aria-hidden="true"
    >
      {icon}
    </span>
    <div className="flex-1 min-w-0 md:flex-none">
      <p
        className={`
          text-xs font-bold tracking-wider
          text-slate-400 uppercase mb-0.5 md:mb-1
        `}
      >
        {teamRole}
      </p>
      <p className="text-sm font-bold text-slate-800 mb-0.5 md:mb-2">
        {title}
      </p>
      <p className="text-xs text-slate-600 leading-snug">
        {description}
      </p>
    </div>
  </article>
);

export default RoleCard;
